// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"136":"89e126dd","155":"649193ab","231":"6cc1dc8c","268":"4e3dfb0e","372":"c710ec5b","448":"20aaa1a4","506":"8edd3596","686":"420857f4","875":"570848ee"}[chunkId] + ".chunk.css";
};